<div class="modal-header">
  <h4 class="modal-title">Product Image</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
    [disabled]="loading"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="d-flex justify-content-center">
    <img
      *ngIf="image"
      [src]="image.full_size_url"
      style="width: 65vw; height: 100%; object-fit: contain"
      class="img-fluid"
    />
  </div>
</div>
<div class="modal-footer">
  <button
    class="btn btn-danger mr-1"
    type="button"
    (click)="deleteImage()"
    [disabled]="loading"
    [ngClass]="{
      'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
    }"
    >Delete Image</button
  >
</div>
